export function addCurrent(calledreportconfig) {
  return {
      type: 'ADD_CURRENT',
      calledreportconfig,
  }
}